const initialState = {
  quantityInfants: 0,
};
  
const quantityInfant = ( state = initialState, action ) => {
  switch (action.type) {
    case 'ADD_QUANTITY_INFANT':
      return {
        ...state,
        quantityInfants: action.quantity,
      };
    case 'REMOVE_QUANTITY_INFANT':
      return {
        ...state,
        quantityInfants: action.quantity,
      };
    default:
      return state;
  }
};
  
export default quantityInfant;
  